<template>
    <page :tabs="tabs">
        <grid :columnDefs="columnDefs" :fetchCallback="fetchCallback"></grid>
    </page>
</template>

<script>
    import API from '../../../api';
    import Page from '../../generic/page/page.vue';
    import Grid from '../../generic/grid/grid.vue';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';

    export default {
        name: 'DigitalSignatureList',
        components: {
            Page,
            Grid,
        },
        mixins: [removeScrollMixin],
        data() {
            return {
                tabs: [
                    {
                        title: 'Setup',
                        route: '/app/digital-signature/setup/',
                        active: false,
                    },
                    {
                        title: 'Requested Signatures',
                        route: '/app/digital-signature/list/',
                        active: true,
                    },
                    {
                        title: 'Pending Signatures',
                        route: '/app/digital-signature/pending/',
                        active: false,
                    },
                ],
                columnDefs: [
                    {
                        field: 'invoice_id',
                        headerName: 'Invoice',
                        sort: 'desc',
                        flex: 0,
                        minWidth: 110,
                        width: 110,
                        cellRenderer: ({ value }) =>
                            `<a href="/app/reservation/edit/invoice/${value}">${value}</a>`,
                    },
                    {
                        field: 'created',
                        headerName: 'Created',
                        type: 'dateColumn',
                        flex: 0,
                        minWidth: 120,
                        width: 120,
                    },
                    {
                        field: 'arrival_date',
                        headerName: 'Arrival Date',
                        type: 'dateColumn',
                        flex: 0,
                        minWidth: 120,
                        width: 120,
                    },
                    {
                        field: 'seen',
                        headerName: 'Seen',
                        type: 'yesNoColumn',
                        flex: 0,
                        minWidth: 90,
                        width: 90,
                    },
                    {
                        field: 'seen_date',
                        headerName: 'Seen On',
                        type: 'dateColumn',
                        cellRendererParams: {
                            noValue: 'Not seen',
                        },
                        flex: 0,
                        minWidth: 130,
                        width: 130,
                    },
                    {
                        field: 'is_signed',
                        headerName: 'Signed',
                        type: 'yesNoColumn',
                        flex: 0,
                        minWidth: 100,
                        width: 100,
                    },
                    {
                        field: 'signed',
                        headerName: 'Signed On',
                        type: 'dateColumn',
                        cellRendererParams: {
                            noValue: 'Not signed',
                        },
                        flex: 0,
                        minWidth: 130,
                        width: 130,
                    },
                    {
                        field: 'source_name',
                        headerName: 'Source',
                        flex: 0,
                        minWidth: 135,
                        width: 135,
                        sortable: false,
                        cellRenderer: ({ data, value }) =>
                            data.is_signed
                                ? value
                                : 'Not signed',                        
                    },                    
                    {
                        field: 'file_name',
                        headerName: 'Download',
                        sortable: false,
                        cellRenderer: ({ data, value }) =>
                            value
                                ? `<a href="${data.absolute_url}">${value}</a>`
                                : 'No file',
                    },
                ],
            };
        },
        computed: {
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    return API.get(
                        encodeURI(
                            `/app/digital-signature/signed-agreement/?offset=${offset}&limit=${limit}&sort=${sort}&desc=${desc}&search=${search}`
                        )
                    );
                };
            },
        },
    };
</script>
